import React, { createContext, useContext, useState } from 'react';
import { COUNTRIES, CountryConfig } from '../constants/countries';

interface CountryContextType {
  activeCountry: CountryConfig;
  setActiveCountry: (code: string) => void;
}

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export const CountryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [activeCountry, setActiveCountryState] = useState<CountryConfig>(() => {
    const saved = localStorage.getItem('pambo_active_country');
    if (saved) {
      const found = COUNTRIES.find((c) => c.code === saved);
      if (found) return found;
    }
    return COUNTRIES[0]; // Default to Kenya
  });

  const setActiveCountry = (code: string) => {
    const found = COUNTRIES.find((c) => c.code === code);
    if (found) {
      setActiveCountryState(found);
      localStorage.setItem('pambo_active_country', code);
      // Dispatch custom event to notify other components/services immediately
      window.dispatchEvent(new Event('countryChanged'));
    }
  };

  return (
    <CountryContext.Provider value={{ activeCountry, setActiveCountry }}>
      {children}
    </CountryContext.Provider>
  );
};

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};
